import { Col, ConfigProvider, Flex, Layout, Progress, Row } from 'antd';
import { TaskDef } from '../../apis/mgmt/api';
import { ClickableProps, DataViewProps, readOnly } from '../common/DataView';
import { Content } from 'antd/es/layout/layout';
import { RecentHealthIndicator, getSemaphoreColor } from '../health/RecentHealthIndicator';
import { useTaskDefListener } from '../../apis/agent/TaskDefListener';
import { Stomp } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { useEffect } from 'react';
import { FieldTimeOutlined } from '@ant-design/icons';
import { get } from 'http';
import { LogSummaryLegend } from '../health/LogSummaryViews';


export const TaskDefCard = function (props:
    DataViewProps<TaskDef> & ClickableProps<TaskDef> & {
        selected?: boolean,
    }
) {

    const { data } = useTaskDefListener({...props, ...readOnly });

    const onClick = () => { data && props.onClick && props.onClick(data); }
    const last = data?.recentHealth?.last;
    const lastExec = data?.lastExec;
    
    const sidePanelVisible = false; // props.sidePanelVisible || false; // TODO Get from context
    const sizes = sidePanelVisible? { xxl: 8, xl: 12, lg: 24 } : { xxl: 4, xl: 6, lg: 8, md: 12, sm: 24 };

    return data && (
        <Col key={data.id} style={{width: '24em'}}> {/* TODO {...sizes} */}
            <div onClick={onClick}
                className={'mig-card mig-card-content pointer ' + (props.selected ? 'selected' : '')} 
                style={{ borderColor: getSemaphoreColor(last?.semaphore) }} 
            >
                <div style={{ width: '100%' }}>
                <Flex vertical gap={10} >
                    <Flex justify='space-between'>
                        <span className='mig-title-3' style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}>{data.name}</span>
                        <RecentHealthIndicator data={data.recentHealth} {...readOnly} />
                    </Flex>
                    <Flex justify='space-between' align='center'>
                        <Flex vertical>
                            <small>{lastExec?.started && `Started ${new Date(lastExec?.started).toLocaleString()}`}</small>
                            <small>
                                {lastExec?.finished && `Finished ${new Date(lastExec?.finished).toLocaleTimeString()}` || '...' }
                                {lastExec?.finished && lastExec.stopped && ' (stopped)' || '' }
                            </small>
                            <small style={{color: 'gray'}}><LogSummaryLegend data={lastExec?.logSummary} {...readOnly} /></small>
                            {lastExec?.logSummary?.fatal && <small style={{color:'red', lineHeight: '1em', maxHeight: '2em', overflow: 'hidden'
                            , textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical'

                            }}>{lastExec?.logSummary?.fatal}</small>}
                        </Flex>
                        <Progress size={80}
                            percent={lastExec?.progress} type="circle" strokeColor={getSemaphoreColor(last?.semaphore)} 
                            status={lastExec?.logSummary?.fatal? 'exception' : 'normal'} 
                        />
                    </Flex>
                </Flex>
                </div>
            </div>
        </Col>
    ) || null;
}
